
class PartFinderForm {
    _MAKES = [{
        id: "mk_acura",
        name: "Acura"
    },
    {
        id: "mk_audi",
        name: "Audi"
    },
    {
        id: "mk_bmw",
        name: "BMW"
    },
    {
        id: "mk_cadillac",
        name: "Cadillac"
    },
    {
        id: "mk_chevrolet",
        name: "Chevrolet"
    },
    {
        id: "mk_dodge",
        name: "Dodge"
    },
    {
        id: "mk_ford",
        name: "Ford"
    },
    {
        id: "mk_gmc",
        name: "GMC"
    },
    {
        id: "mk_jeep",
        name: "Jeep"
    },
    {
        id: "mk_honda",
        name: "Honda"
    },
    {
        id: "mk_lincoln",
        name: "Lincoln"
    },
    {
        id: "mk_mazda",
        name: "Mazda"
    },
    {
        id: "mk_mercedes-benz",
        name: "Mercedes-Benz"
    },
    {
        id: "mk_nissan",
        name: "Nissan"
    },
    {
        id: "mk_porsche",
        name: "Porsche"
    },
    {
        id: "mk_ram",
        name: "Ram"
    },
    {
        id: "mk_scion",
        name: "Scion"
    },
    {
        id: "mk_subaru",
        name: "Subaru"
    },
    {
        id: "mk_toyota",
        name: "Toyota"
    },
    {
        id: "mk_volkswagen",
        name: "Volkswagen"
    }
    ];
    constructor(reference) {

        this.container = document.querySelector(reference);

        if (!this.container) {
            throw new Error('Custom part finder: container not found')
        }
        else {
            this.customHeader = new Headers();
            this.customHeader.append("Content-Type", "application/json");

            this.reqOptions = {
                method: "GET",
                Headers: [
                    "Content-Type:application/json"
                ],
                mode: "no-cors",
                redirect: "follow",
            }

        }


    }
    make = async (event) => {
        event.target.querySelector("#please-select").disabled = true;
        const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery111003058814613446805_1746117865070&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_2&prev_val=" + [event.target.options[event.target.selectedIndex].value] + "&current_val=" + [event.target.options[event.target.selectedIndex].value] + "&lang_code=en&pri_lang_code=&_=1746117865079";
        const data = await this.makeRequest(url)
        let $model = this.container.querySelector(".model");
        $model.textContent = "";
        let newSelect = document.createElement('ul');
        newSelect.innerHTML = data.html;

        for (let option of Array.from(newSelect.querySelectorAll('option'))) {
            $model.appendChild(option);
        }


        $model.removeAttribute('disabled');
        $model.selectedIndex = 0
        this.container.querySelector(".model").selectedIndex = 0;
        this.container.querySelector(".year").selectedIndex = 0;
        if (this.container.querySelector(".submodel")) {
            this.container.querySelector(".submodel").selectedIndex = 0;
            this.container.querySelector(".engine").selectedIndex = 0;
            this.container.querySelector(".transmission").selectedIndex = 0;
        }

        // $model.dispatchEvent(new Event('change'))

    }
    model = async (event) => {
        event = event.target;
        let $year = this.container.querySelector(".year");
        $year.textContent = "";

        const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery1110023537087433045767_1746130184965&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_3&prev_val=" + this.container.querySelector(".make").value + "%2C" + event.options[event.selectedIndex].value + "&current_val=" + event.options[event.selectedIndex].value
        const data = await this.makeRequest(url)
        let newSelect = document.createElement('ul');
        newSelect.innerHTML = data.html;

        for (let option of Array.from(newSelect.querySelectorAll('option'))) {
            $year.appendChild(option);
        }

        $year.removeAttribute('disabled');
        $year.selectedIndex = 0
        this.container.querySelector(".year").selectedIndex = 0;
        if (this.container.querySelector(".submodel")) {
            this.container.querySelector(".submodel").selectedIndex = 0;
            this.container.querySelector(".engine").selectedIndex = 0;
            this.container.querySelector(".transmission").selectedIndex = 0;
        }

        // $year.dispatchEvent(new Event('change'))

    }
    year = async (event) => {

        let $submodel = this.container.querySelector(".submodel");
        if ($submodel) {
            $submodel.textContent = "";
            const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery1110008340386536275224_1746131193856&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_1&prev_val=" + this.container.querySelector(".make").value + "%2C" + this.container.querySelector(".model").value + "%2C" + event.target.options[event.target.selectedIndex].value + "&current_val=" + event.target.options[event.target.selectedIndex].value + "&lang_code=en&pri_lang_code=&_=1746131193861"
            const data = await this.makeRequest(url)
            let newSelect = document.createElement('ul');
            newSelect.innerHTML = data.html;

            for (let option of Array.from(newSelect.querySelectorAll('option'))) {
                $submodel.appendChild(option);
            }

            $submodel.removeAttribute('disabled');
            $submodel.selectedIndex = 0;

            this.container.querySelector(".submodel").selectedIndex = 0;
            this.container.querySelector(".engine").selectedIndex = 0;
            this.container.querySelector(".transmission").selectedIndex = 0;
        }

        // $submodel.dispatchEvent(new Event('change'))
    }
    submodel = async (event) => {

        const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery111006848422405938119_1746198888036&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_4&prev_val=" + this.container.querySelector(".make").value + "%2C" + this.container.querySelector(".model").value + "%2C" + this.container.querySelector(".year").value + "%2C" + event.target.options[event.target.selectedIndex].value + "&current_val=" + event.target.options[event.target.selectedIndex].value + "&lang_code=en&pri_lang_code=&_=1746198888043"
        const data = await this.makeRequest(url);
        let $engine = this.container.querySelector(".engine");
        $engine.textContent = "";
        let newSelect = document.createElement('ul');
        newSelect.innerHTML = data.html;
        for (let option of Array.from(newSelect.querySelectorAll('option'))) {
            $engine.appendChild(option);
        }

        $engine.removeAttribute('disabled');
        $engine.selectedIndex = 0;
        this.container.querySelector(".engine").selectedIndex = 0;
        this.container.querySelector(".transmission").selectedIndex = 0;
        // $engine.dispatchEvent(new Event('change'))
    }


    engine = async (event) => {

        const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery111005574599626040451_1746199142212&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_5&prev_val=" + this.container.querySelector(".make").value + "%2C" + this.container.querySelector(".model").value + "%2C" + this.container.querySelector(".year").value + "%2C" + this.container.querySelector(".submodel").value + "%2C" + event.target.options[event.target.selectedIndex].value + "&current_val=" + event.target.options[event.target.selectedIndex].value + "&lang_code=en&pri_lang_code=&_=1746199142221"

        const data = await this.makeRequest(url);

        let $transmission = this.container.querySelector(".transmission");
        $transmission.textContent = "";
        if (!data) {
            return false;
        }
        let newSelect = document.createElement('ul');
        newSelect.innerHTML = data.html;
        for (let option of Array.from(newSelect.querySelectorAll('option'))) {
            $transmission.appendChild(option);
        }
        $transmission.selectedIndex = 0
        $transmission.removeAttribute('disabled');

        this.container.querySelector(".transmission").selectedIndex = 0;
        // $transmission.dispatchEvent(new Event('change'))
    }

    transmission = () => { }
    makeRequest = async (url) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                dataType: 'jsonp',
                success: function (data) {
                    resolve(data);
                },
                error: function () {
                    reject("Ajax error");
                }
            });
        })
    }
    init = async () => {
        const localValues = localStorage.getItem('part_finder_mk')
        if(localValues){
            this._MAKES = JSON.parse(localValues)
        }
        this._MAKES.forEach((item) => {
            let newOption = document.createElement("option");
            newOption.value = item.id;
            newOption.innerText = item.name;
            this.container.querySelector(".make").appendChild(newOption);
        });
        this.container.querySelector(".make").addEventListener('change', async (event) => await this.make(event))
        this.container.querySelector(".model").addEventListener('change', async (event) => await this.model(event))
        this.container.querySelector(".year").addEventListener('change', async (event) => await this.year(event))
        if (this.container.querySelector(".submodel")) {
            this.container.querySelector(".submodel").addEventListener('change', async (event) => await this.submodel(event))
            this.container.querySelector(".engine").addEventListener('change', async (event) => await this.engine(event))
        }


    }
}

window.PartFinderForm = PartFinderForm